(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/unionBy', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/unionBy'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.unionBy, global.convert);
    global.unionBy = mod.exports;
  }
})(this, function (exports, _unionBy2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.unionBy = undefined;

  var _unionBy3 = _interopRequireDefault(_unionBy2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.union} except that it accepts <code>iteratee</code> to generate the criterion by which elements are compared.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} [arrays] The arrays to inspect.
   * @param {Function} [iteratee={@link https://lodash.com/docs#identity|lodash.identity}] The iteratee invoked per element.
   * @return {Object} Returns the updated object.
   * @example unionBy({ nested: { prop: [{ x: 1 }, { x: 2 }] } }, 'nested.prop', [{ x: 2 }, { x: 3 }], 'x') // => { nested: { prop: [{ x: 1 }, { x: 2 }, { x: 3 }] } }
   * @see {@link https://lodash.com/docs#unionBy|lodash.unionBy} for more information.
   * @since 0.3.0
   */
  var unionBy = (0, _convert.convert)(_unionBy3.default);
  exports.unionBy = unionBy;
  exports.default = unionBy;
});